// extracted by mini-css-extract-plugin
export var ageButton = "ageConsentBanner-module--ageButton--rFVS8";
export var confirmButton = "ageConsentBanner-module--confirmButton--pzgfe";
export var modalBody = "ageConsentBanner-module--modalBody--7tG9h";
export var modalContent = "ageConsentBanner-module--modalContent--T3AdW";
export var modalLogo = "ageConsentBanner-module--modalLogo--LGzco";
export var modalOptions = "ageConsentBanner-module--modalOptions--YXruu";
export var modalOverlay = "ageConsentBanner-module--modalOverlay--YUoR0";
export var modalQuestion = "ageConsentBanner-module--modalQuestion--ovo60";
export var modalText = "ageConsentBanner-module--modalText--He8hH";
export var modalTitle = "ageConsentBanner-module--modalTitle--A+Mbc";
export var optionButton = "ageConsentBanner-module--optionButton--9flNL";